<template>
    <div>
        <b-button
                variant="outline-primary"
                size="sm"
                @click="() => this.$refs['editor-modal'].show()"
        >
            <b-icon icon="pencil"/>
        </b-button>

        <b-modal
                ref="editor-modal"
                title="Suprascrie denumirea produsului"
                @ok="handleSave"
        >
            <b-alert show variant="info">
                <p>
                    Utilizând această fereastră, puteți suprascrie denumirea produsului
                    <em>{{ defaultName }}</em>.
                </p>

                <p>
                    Această modificare a ofertei va fi vizibilă atât în platformă, cât și în variantele
                    exportate ale acesteia.
                </p>
            </b-alert>

            <b-form-group
                label="Denumirea nouă"
                description="Lăsați câmpul liber pentru a șterge denumirea suprascrisă."
            >
                <b-form-input
                    v-model="editedName"
                    type="text"
                    placeholder="Introdu denumirea nouă..."
                ></b-form-input>
            </b-form-group>

            <template #modal-footer="{ ok, cancel }">
                <!-- Button with custom close trigger value -->
                <b-button size="sm" variant="danger" @click="handleResetName">
                    Ștergere denumire
                </b-button>

                <b-button size="sm" variant="secondary" @click="cancel()">
                    Anulare
                </b-button>

                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="sm" variant="success" @click="ok()">
                    Salvare
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "ItemNameEditor",
    data() {
        return {
            editedName: null,
        };
    },
    props: [
        'defaultName',
        'customName'
    ],
    created() {
        if(!this.customName) {
            this.editedName = this.defaultName;
        } else {
            this.editedName = this.customName;
        }
    },
    methods: {
        handleSave() {
            this.$emit('saveName', this.editedName)
            this.$refs['editor-modal'].hide();
        },
        handleResetName() {
            this.editedName = null;
            this.handleSave();
        }
    }
}
</script>

<style scoped>

</style>